var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "dark-theme",
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "교육 · 법률지원",
            "src": "/images/sub/sub-visual-education.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm.application ? _c('div', {
    staticClass: "board-container"
  }, [_c('h5', {
    staticClass: "tit tit--xxs mb-12px mb-md-20px"
  }, [_vm._v(_vm._s(_vm.application.subject))]), _c('table', {
    staticClass: "board-view"
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("작성일 : " + _vm._s(_vm.application.createdAt.toDate()))])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-view mr-4px"
  }), _vm._v(" " + _vm._s(_vm.application.viewCount) + " ")])], 1)], 1)], 1)]), _vm.application.files ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('span', {
    staticClass: "mr-10px"
  }, [_vm._v("첨부파일")]), _c('v-row', {
    staticClass: "row--xxs"
  }, _vm._l(_vm.application.files, function (file, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      staticClass: "grey--text",
      attrs: {
        "x-small": "",
        "color": "grey lighten-5"
      },
      on: {
        "click": function click($event) {
          _vm.download(file, file.name.split('/').pop());
        }
      }
    }, [_vm._v(" " + _vm._s(file.name.split('/').pop()) + " ")])], 1);
  }), 1)], 1)], 1)]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "content_box",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.application.content.replace(/\n/g, '<br>'))
    }
  })])])]), _c('v-layout', {
    staticClass: "mt--md",
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "grey lighten-3"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("리스트")])])], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }